import React from 'react';

import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import * as styles from './image-grid-columns.module.css';

export function ImageGridWithColumns({
  backgroundColor,
  fadeEffects,
  hideOnMobile,
  images,
  verticalPadding
}) {
  // content padding
  const modulePaddingTop = verticalPadding?.modulePaddingTop;
  const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

  // fade effects
  const enableFadeEffect = fadeEffects?.enableFadeEffect;
  const fadeEffectType = fadeEffects?.fadeEffectType;
  const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

  return (
    <div
      className={
        classNames(
          backgroundColor && `b${backgroundColor}`,
          hideOnMobile && styles.hideOnMobile,
          styles.moduleContainer,
        )
      }
    >
      <div
        className={
          classNames(
            modulePaddingBottom,
            modulePaddingTop,
            styles.contentContainer
          )
        }
      >
        <div
          className={
            classNames(
              fadeEffectType && fadeEffectType,
              styles.gridContainer
            )
          }
        >
          {images?.map((image, idx) => {
            const columnImage = getImage(image?.asset);
            const previewImage = image?.asset?.url;

            return (
              <div
                className={
                  classNames(
                    enableFadeEffect && 'reveal',
                    fadeEffectDirection && fadeEffectDirection
                  )
                }
                id={`grid-img-col-1-${idx + 1}`}
                key={image._key}
              >
                {columnImage && (
                  <GatsbyImage
                    alt={image?.alt || ''}
                    className={styles.image}
                    image={columnImage}
                  />
                )}
                {!columnImage && (
                  <img
                    alt={image?.alt || ''}
                    className={styles.image}
                    src={previewImage}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
